import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useCallback, useEffect, useMemo } from 'react';
import { createBatches } from './batch';
import { mergeSlotsWithItems } from './slots';
export var Context = /*#__PURE__*/React.createContext();
export default function useItems(itemCount, slots, stepSize, targetBatchSize, maxBatchCount, getItems, loadItems) {
  var itemCountUnknown = itemCount == null;
  var batches = useMemo(function () {
    if (itemCount == null) {
      return [];
    }

    var batches = createBatches({
      itemCount: itemCount,
      slots: slots,
      stepSize: stepSize,
      targetBatchSize: targetBatchSize,
      maxBatchCount: maxBatchCount
    });
    return batches;
  }, [itemCount, slots, stepSize, targetBatchSize, maxBatchCount]);
  var getItemsWithSlots = useCallback(function (_ref) {
    var startIndex = _ref.startIndex,
        stopIndex = _ref.stopIndex,
        slots = _ref.slots,
        rest = _objectWithoutProperties(_ref, ["startIndex", "stopIndex", "slots"]);

    var items = getItems(_objectSpread({
      startIndex: startIndex,
      stopIndex: stopIndex,
      slots: slots
    }, rest));
    return mergeSlotsWithItems({
      slots: slots,
      items: items,
      startIndex: startIndex,
      stopIndex: stopIndex
    });
  }, [getItems]);
  useEffect(function () {
    if (itemCountUnknown) {
      loadItems({
        startIndex: 0,
        stopIndex: targetBatchSize
      });
    }
  }, [itemCountUnknown, loadItems, targetBatchSize]);
  return {
    batches: batches,
    getItemsWithSlots: getItemsWithSlots
  };
}